export default "__VITE_ASSET__f0CM0E15__"